/**
 * Mobile-only top bar that hosts the SidebarTrigger so users on narrow
 * viewports can open the offcanvas sidebar. Hidden on lg+ where the
 * sidebar is permanently visible.
 */

import { SidebarTrigger } from "@/components/ui/sidebar"
import { useCurrentWorkspace } from "@/store/slices/workspace-slice"
import logoIcon from "@/assets/images/logo-icon.png"

export function AppMobileTopBar() {
  const currentWorkspace = useCurrentWorkspace()
  return (
    <div
      className="lg:hidden sticky top-0 z-30 flex shrink-0 items-center gap-2 border-b bg-background/95 px-3 backdrop-blur supports-[backdrop-filter]:bg-background/80"
      style={{
        paddingTop: "env(safe-area-inset-top)",
        height: "calc(3.5rem + env(safe-area-inset-top))",
      }}
    >
      <SidebarTrigger aria-label="Open sidebar" />
      <div className="flex min-w-0 items-center gap-2">
        <img src={logoIcon} alt="" className="size-7 shrink-0 object-contain" />
        <span className="truncate text-base font-semibold">
          <span className="text-foreground">Team</span>
          <span className="text-primary">Mate</span>
          {currentWorkspace?.name && (
            <span className="ml-2 text-sm font-medium text-muted-foreground">
              · {currentWorkspace.name}
            </span>
          )}
        </span>
      </div>
    </div>
  )
}

AppMobileTopBar.displayName = "AppMobileTopBar"
